import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  onClick?: () => void;
}
export function Button({
  children,
  fullWidth = false,
  onClick,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        relative overflow-hidden rounded-sm bg-gradient-to-b from-gold-400 to-gold-600 
        px-8 py-4 text-navy-900 font-semibold tracking-wide shadow-[0_0_20px_rgba(212,168,87,0.3)]
        transition-shadow hover:shadow-[0_0_30px_rgba(212,168,87,0.5)]
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-29">
      <div className="absolute inset-0 bg-white/20 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-30"></div>
      <span className="relative z-10 flex items-center justify-center gap-2 text-[15px] sm:text-base uppercase tracking-wider font-sans" data-id="element-31">
        {children}
      </span>
    </motion.button>;
}